// ==============================|| BREAK TIME ICON ||============================== //

const BreakTimeIcon = ({ color = '#000', width = 24, className = '' }) => {
  const commonStyle = {
    fill: color,
    strokeWidth: '0px',
  };

  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M37.1,22.9c-.4-.4-1-.4-1.4,0l-4.4,4.4s-.2,0-.3-.1v-11.2c0-.6-.5-1-1-1s-1,.4-1,1v11.2c-1.2.4-2,1.5-2,2.8s1.3,3,3,3,3-1.3,3-3,0-.9-.3-1.3l4.4-4.4c.4-.4.4-1,0-1.4ZM57.7,37h-4.3c-.5-.7-1.4-1.2-2.4-1.2h-14.6c-1.7,0-3,1.3-3,3v7.3c0,4.1,2.4,7.6,5.9,9.3h-8.4l.9,3c.3,1,1.2,1.6,2.2,1.6h19.2c1,0,1.9-.7,2.2-1.6l.9-3h-8.3c2.5-1.2,4.5-3.4,5.3-6l1.2-.2c3.6-.6,6.2-3.7,6.2-7.4v-1.5c0-1.8-1.5-3.3-3.3-3.3h.3ZM59,41.8c0,2.7-1.9,5-4.6,5.4h-.4v-8.2h3.6c.7,0,1.3.6,1.3,1.3v1.5h.1Z"
        style={commonStyle}
      />
      <path
        d="M33.9,53.4c-.4-.5-.7-1-1-1.6-.6,0-1.3.2-1.9.2v-2c0-.5-.5-1-1-1s-1,.5-1,1v2c-5.3-.2-10.2-2.4-13.8-5.7l1.4-1.4c.4-.4.4-1,0-1.4s-1-.4-1.4,0l-1.4,1.4c-3.4-3.7-5.5-8.5-5.7-13.8h2c.6,0,1-.5,1-1s-.4-1-1-1h-2c.2-5.3,2.4-10.2,5.7-13.8l1.4,1.4c.2.2.4.3.7.3s.5-.1.7-.3c.4-.4.4-1,0-1.4l-1.4-1.4c3.7-3.4,8.5-5.5,13.8-5.7v2c0,.6.5,1,1,1s1-.4,1-1v-2c5.3.2,10.2,2.4,13.8,5.7l-1.4,1.4c-.4.4-.4,1,0,1.4.2.2.5.3.7.3s.5-.1.7-.3l1.4-1.4c3.4,3.7,5.5,8.5,5.7,13.8h-2c-.5,0-1,.5-1,1s.5,1,1,1h2c0,1-.2,1.9-.3,2.8,1,0,1.9.5,2.6,1.1h1.3c.3-1.6.5-3.3.5-5,0-14.4-11.6-26-26-26S4,15.6,4,30s11.2,25.5,25.1,26h0c-.2-.6,0-1.3.3-1.8.4-.5,1-.8,1.6-.8h2.9Z"
        style={commonStyle}
      />
    </svg>
  );
};

export default BreakTimeIcon;
